<template>
    <IndumentariasComponent v-if="base.categoria_base.tiene_indumentarias" :base="base" :paso_activo="true" @terminado="terminar" @volver="volver" />
</template>

<script>
    import IndumentariasComponent from "@/components/frontend/bases/PasoCincoComponent";

    export default {
        props: ['base'],
        methods: {
            terminar(indumentariasElegidas) {
                this.$emit('terminado', indumentariasElegidas);
            },
            volver() {
                this.$emit('volver');
            }
        },
        components: {
            IndumentariasComponent
        }
    }
</script>